
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        //IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
    function getOrderAttributesQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getOrderAttributesInput (
        orderId:
            string
    ): IDataServiceRequest {
      const query = getOrderAttributesQuery();
      return query.createDataServiceRequestForOperation(
          'GetOrderAttributes',
          false, 
            DataServiceEntities.GetOrderAttributesResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetOrderAttributesResponse' },
          {
          orderId: orderId
          }
      );
    }

    export function getOrderAttributesAsync (
        context: IContext, orderId:
            string
        ): AsyncResult<DataServiceEntities.IGetOrderAttributesResponse> {
        const request = getOrderAttributesInput(orderId);
        return callActionOrExecute<DataServiceEntities.IGetOrderAttributesResponse>(request, context.callerContext);
        }
      
    function getUserInfoQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getUserInfoInput (
        email:
            string
    ): IDataServiceRequest {
      const query = getUserInfoQuery();
      return query.createDataServiceRequestForOperation(
          'GetUserInfo',
          false, 
            DataServiceEntities.GetUserInfoResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetUserInfoResponse' },
          {
          email: email
          }
      );
    }

    export function getUserInfoAsync (
        context: IContext, email:
            string
        ): AsyncResult<DataServiceEntities.IGetUserInfoResponse> {
        const request = getUserInfoInput(email);
        return callActionOrExecute<DataServiceEntities.IGetUserInfoResponse>(request, context.callerContext);
        }
      
    function checkDataQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function checkDataInput (
        
    ): IDataServiceRequest {
      const query = checkDataQuery();
      return query.createDataServiceRequestForOperation(
          'CheckData',
          false, 
            ''
          ,
          'false',
          { bypassCache: 'get', returnEntity: '' },
          {
          
          }
      );
    }

    export function checkDataAsync (
        context: IContext
        ): AsyncResult<string> {
        const request = checkDataInput();
        return callActionOrExecute<string>(request, context.callerContext);
        }
      